module.exports = __webpack_public_path__ + "media/app-store-detail/GetApp_white-e688dccb.png";